export default "__VITE_ASSET__reurxlk6__"